const budgetDriversQueryKeys = {
  all: [{ scope: 'budgetDrivers' }] as const,
  lists: () => [{ ...budgetDriversQueryKeys.all[0], entity: 'list' }] as const,
  list: (context: { companyId?: string | null }) => [{ ...budgetDriversQueryKeys.lists()[0], ...context }] as const
}

export default budgetDriversQueryKeys
